'use strict';

var _ = require('lodash');
var IdService = function IdService() {
  var LEG_ID_REG_EXP = /(\w+)\.(\w+)\.(\d+)\[(.*)]\.(\w+)/g;
  var FLIGHT_ID_REG_EXP = /([A-Z0-9]{2})\.(\d+)\[([-\d]+)\]/;
  var SERVICE_ID_REG_EXP = /([A-Z]{3})\.[^.]+\.([\d]+)[^.]+\.([A-Z]{3})/g;
  var SERVICE_CLASS_ID_REG_EXP = /([A-Z]{3})\.([A-Z0-9]{2})\.(\d+)\[([-\d]+)\]\.([A-Z]{3})(\.([A-Z])\.(\w+))?/;

  /**
   * Parse legId string and break it into matched groups
   * @param id string
   * @returns {{origin: *, airline: *, flightNumber: *, departureDate: *, destination: *}}
   */
  function parseLegId(id) {
    var result = {};
    id.replace(LEG_ID_REG_EXP, function () {
      var matches = _.chain(arguments).toArray().tail().value();
      result = _.zipObject(['origin', 'airlineCode', 'flightNumber', 'departureDate', 'destination'], matches);
    });
    return result;
  }

  /**
   * Parse serviceId string and build service name
   * @param id string
   * @returns {string} service name
   */
  function parseServiceId(id) {
    return id.replace(SERVICE_ID_REG_EXP, '$2 $1-$3').replace(/\|/g, ' - ');
  }

  /**
   * Parse flightId string
   * @param id string
   * @returns {Array} an array of parsed objects
   */
  function parseFlightId(id) {
    var m = id.match(FLIGHT_ID_REG_EXP);
    if (!_.isNull(m)) {
      return {
        carrier: m[1],
        flight: m[2],
        departureDate: m[3]
      };
    }
  }

  /**
   * Parse serviceClassId string
   * @param id string
   * @returns {Array} an array of parsed objects
   */
  function parseServiceClassId(id) {
    return _.chain(id.split('|')).map(function (chunk) {
      var m = chunk.match(SERVICE_CLASS_ID_REG_EXP);
      if (!_.isNull(m)) {
        return {
          origin: m[1],
          carrier: m[2],
          flight: m[3],
          departureDate: m[4],
          destination: m[5],
          serviceClass: m[7],
          pos: m[8]
        };
      }
    }).tap(function (result) {
      var lastChunk = _.last(result);
      _.forEach(result, function (r) {
        if (!_.isUndefined(r)) {
          r.pos = lastChunk.pos;
          r.serviceClass = lastChunk.serviceClass;
        }
      });
    }).value();
  }
  return {
    parseLegId: parseLegId,
    parseServiceId: parseServiceId,
    parseFlightId: parseFlightId,
    parseServiceClassId: parseServiceClassId
  };
};
IdService.$inject = [];
module.exports = IdService;